import { AbstractAnimationVO } from "./AbstractAnimationVO";

import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import Container = createjs.Container;

export class HotspotAnimationVO extends AbstractAnimationVO {
    public playerContainer: MovieClip;
    public animationContainer: Container;
    public tableScreen: DisplayObject;

    constructor(playerContainer: MovieClip, animationContainer: Container, tableScreen: DisplayObject) {
        super();
        this.playerContainer = playerContainer;
        this.animationContainer = animationContainer;
        this.tableScreen = tableScreen;
    }
}
